import { UIWidgetsDiv, UIWidgetsDivGrid } from "./Division";

const DivHOC = (PassedComponent) =>
  ({ ref, handleOnClick, children, ...rest }) => (
    <PassedComponent
      ref={ref}
      data-testid="div-hoc"
      onClick={() => handleOnClick && handleOnClick()}
      handleOnClick={handleOnClick}
      {...rest}
    >
      {children}
    </PassedComponent>
  );

export default DivHOC;


